import { ref, computed } from "vue";
import firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";

const state = ref({ todos: [], selected: null });
export default function useTodos() {
  const projectsRef = firebase.firestore().collection("projects");

  async function fetchTodos(projectId) {
    const todos = [];
    try {
      const res = await projectsRef
        .doc(projectId)
        .collection("todos")
        .orderBy("timestamp", "asc")
        .get();
      if (!res.empty) {
        res.forEach(doc => {
          const todo = doc.data();
          todo.id = doc.id;
          todo.editText = todo.text;
          const time =
            todo.timestamp.seconds * 1000 +
            todo.timestamp.nanoseconds / 1000000;
          todo.timestamp = moment(time).toDate();
          todos.push(todo);
        });
      }
    } catch (err) {
      console.log(err);
    }

    state.value.todos = todos;
    return state.value.todos;
  }

  async function saveTodo(todo, projectId) {
    todo.timestamp = firebase.firestore.FieldValue.serverTimestamp();
    try {
      const res = await projectsRef
        .doc(projectId)
        .collection("todos")
        .add(todo);

      todo.id = res.id;
      todo.editText = todo.text;
      state.value.todos.push(todo);
      return todo.id;
    } catch (err) {
      console.log(err);
    }
  }

  async function checkTodo(projectId, todoId, checkVal) {
    try {
      await projectsRef
        .doc(projectId)
        .collection("todos")
        .doc(todoId)
        .update({ checked: checkVal });
    } catch (err) {
      console.log(err);
    }
  }

  async function deleteTodo(projectId, todoId) {
    try {
      await projectsRef
        .doc(projectId)
        .collection("todos")
        .doc(todoId)
        .delete();
    } catch (err) {
      console.log(err);
    }

    const deleteIndex = state.value.todos.findIndex(item => item.id === todoId);
    if (deleteIndex !== -1) {
      state.value.todos.splice(deleteIndex, 1);
    }
  }

  async function editTodoText(projectId, todoId, newText) {
    try {
      await projectsRef
        .doc(projectId)
        .collection("todos")
        .doc(todoId)
        .update({ text: newText });
    } catch (err) {
      console.log(err);
    }
  }

  function resetTodoEdit(todoId) {
    const itemToReset = state.value.todos.find(todo => todo.id === todoId);
    if (itemToReset) {
      itemToReset.editText = itemToReset.text;
    }
  }

  return {
    fetchTodos,
    saveTodo,
    checkTodo,
    editTodoText,
    resetTodoEdit,
    deleteTodo,
    todos: computed(() => {
      return state.value.todos;
    })
  };
}
